import styled from 'styled-components';

export const Wrapper = styled.div`
  display: grid;
  grid-gap: 24px;

  @media screen and (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (min-width: 1024px) {
    grid-gap: 32px;
  }

  @media screen and (min-width: 1280px) {
    grid-template-columns: 1fr 1fr 1fr;
  }

  @media screen and (min-width: 1536px) {
    grid-gap: 48px;
  }
`;
